import React from 'react';

interface TextClassificationIconProps {
  style?: React.CSSProperties;
}

const TextClassificationIcon: React.FC<TextClassificationIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Text Classification</title>
      <path d="M19.485 3.75L12.99 0 0 7.5V15l11.688-4.686 7.797-6.564z" fill="#6A11EA" />
      <path d="M6.495 26.25L12.99 30l12.99-7.5V15l-9.654 3.522-9.831 7.728z" fill="#FD9D52" />
      <path d="M19.485 3.75L0 15v7.5l6.495 3.75L25.98 15V7.5l-6.495-3.75z" fill="#943CFF" />
      <path
        d="M13.248 11.781v6.711l3.078 2.082 6.402-3.696L25.98 15V7.5l-6.495-3.75-11.367 6.564 5.13 1.467z"
        fill="#DD45D3"
      />
      <path
        d="M8.118 10.314v4.104h2.052v-2.052h2.052v6.156H10.17v2.052h6.156v-2.052h-2.052v-6.156h2.052v2.052h2.052v-4.104H8.118z"
        fill="#fff"
      />
    </svg>
  );
};

export default TextClassificationIcon;
